<template>
  <div class="Navbar">
    <section class="hero is-white" style="text-align:start;border-bottom: medium solid #4a4a4a;">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">プログラミング</h1>
          <h2 class="subtitle">自分だけのじゃんけんAIを作ってみよう！</h2>
        </div>
      </div>
    </section>
  </div>
</template>>
<script>
export default {
  data() {
    return {
      isActive: "coding"
    };
  }
};
</script>
<style scoped>
html {
  
}
</style>